export default __webpack_public_path__ + "static/media/Q32025.84eb69bc.pdf";